import { Component, OnInit } from '@angular/core';
import { AdminComponent } from '../admin.component';
import { AdminService } from '../admin.service';
import { MyAppointmentsService} from './my-appointments.service'

@Component({
  selector: 'app-my-appointments',
  templateUrl: './my-appointments.component.html',
  styleUrls: ['./my-appointments.component.css']
})
export class MyAppointmentsComponent implements OnInit {
  isAppointmentsLoading: boolean;
  appointmentList: any[] = [];
  selectedAppointment: any = {};
  selectedServiceName: any = '';

  constructor(
    private MyAppointmentsService: MyAppointmentsService,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.isAppointmentsLoading = false;
    this.loadAppointments();
  }

  loadAppointments() {
    this.isAppointmentsLoading = true;
    this.MyAppointmentsService.appointmentList().subscribe((data: any) => {
      this.appointmentList = data.success.userAppointment;
      this.isAppointmentsLoading = false;
    });
  }

  onSelectAppointment(appointmentId, serviceName) {
    this.selectedServiceName = serviceName;
    this.adminService.details({Id:appointmentId}).subscribe((data: any) => {
      this.selectedAppointment = data.success.userQuery;
    });
  }

}
